document.querySelectorAll('.readmore-container').forEach(container => {
    const wrapper = container.querySelector('.readmore-wrapper');
    const toggle = container.querySelector('.readmore-toggle');

    toggle.addEventListener('click', () => {
    const expanded = wrapper.classList.toggle('expanded');
    const fade = container.querySelector('.readmore-fade');

    toggle.textContent = expanded ? 'Read Less' : 'Read More';
    toggle.classList.toggle('hide', expanded);

    // Fade overlay adjustment
    if (fade) fade.style.opacity = expanded ? '0' : '1';

    // Smoothly show/hide button text
    setTimeout(() => toggle.classList.remove('hide'), 300);
    });
});